export default "__VITE_ASSET__CDu0uZIO__"